import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { finalize } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { FeedbackService } from '@core/services/feedback.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CheckboxModule,
    InputTextModule,
    TooltipModule,
    RouterLink,
  ],
  providers: [],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnInit {
  private readonly fb = inject(FormBuilder);
  private readonly authService = inject(AuthService);
  private readonly feedback = inject(FeedbackService);
  private readonly router = inject(Router);

  formLogin!: FormGroup;
  loading = false;
  showPassword = false;

  ngOnInit(): void {
    this.formLogin = this.fb.group({
      username: [null, [Validators.required]],
      password: [null, [Validators.required]],
      remember: [false],
    });
  }

  toggleVisiblePassword(): void {
    this.showPassword = !this.showPassword;
  }

  isInvalid(controlName: 'username' | 'password'): boolean {
    const control = this.formLogin.get(controlName);
    return !!(control?.touched && control.invalid);
  }

  submit(): void {
    if (this.formLogin.invalid) {
      this.formLogin.markAllAsTouched();
      this.feedback.showWarning('Preencha os campos de utilizador e palavra-passe.', {
        summary: 'Formulário Incompleto',
        life: 4000,
      });
      return;
    }

    this.loading = true;
    const { username, password } = this.formLogin.value;

    this.authService
      .login(username, password)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: () => {
          if (this.authService.isAdmin()) {
            this.router.navigate(['/admin']);
          } else {
            this.authService.logout();
            this.feedback.showWarning(
              'O utilizador não possui acesso ao Backoffice.',
              {
                summary: 'Acesso Não Autorizado',
                life: 5500,
              },
            );
          }
        },
        error: (err) => {
          const detail = this.feedback.extractErrorMessage(
            err,
            'Utilizador ou palavra-passe inválidos.',
          );

          this.feedback.showError(err, {
            summary: 'Falha no login',
            detail,
            life: 5500,
          });
        },
      });
  }
}
